import React from "react";
var __jsx = React.createElement;
var BrandGeneralInformation = function BrandGeneralInformation(_ref) {
  var title = _ref.title,
    content = _ref.content;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary-old font-bold text base leading-12"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text text-base font-medium leading-8",
    dangerouslySetInnerHTML: {
      __html: content
    }
  })));
};
export default BrandGeneralInformation;